import { render, staticRenderFns } from "./myColletionOrder.vue?vue&type=template&id=3c122304&scoped=true"
import script from "./myColletionOrder.vue?vue&type=script&lang=js"
export * from "./myColletionOrder.vue?vue&type=script&lang=js"
import style0 from "./myColletionOrder.vue?vue&type=style&index=0&id=3c122304&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c122304",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c122304')) {
      api.createRecord('3c122304', component.options)
    } else {
      api.reload('3c122304', component.options)
    }
    module.hot.accept("./myColletionOrder.vue?vue&type=template&id=3c122304&scoped=true", function () {
      api.rerender('3c122304', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/child/myColletionOrder.vue"
export default component.exports